import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch, batch } from 'react-redux';
import { useImmer } from 'use-immer';
import axios from 'axios';
import { Range } from 'rc-slider';
import { MultiSelect } from "react-multi-select-component";
import _ from 'lodash';
import filterAction from '../../actions/filterAction';
import { useLocation } from 'react-router-dom';

const setRelation = (d) => {
  let uniqueArray = !1,
  values = [];
  var i = d.val.length - 1;
  while (i>=0) {
    values = [...values,d.val[i].value]
    i--;
  }
  if(values.length){
    let res = [];
    var i = d.arr.length - 1;
    while (i>=0) {
      if(values.indexOf(d.arr[i][d.col[0]]) > -1 && d.arr[i][d.col[1]]){
        res = [...res,{label: d.arr[i][d.col[1]], value: d.arr[i][d.col[1]]}]
      }
      i--;
    }

    uniqueArray = res.filter((dat, i) => {
      const _dat = JSON.stringify(dat);
      return i === res.findIndex(obj => {
        return JSON.stringify(obj) === _dat;
      });
    });


    uniqueArray.sort((a, b) => (a.value > b.value) ? 1 : -1)
  }

  return uniqueArray;
}

const yearIntervals = () => {
  let y = [];
  let i = 1959;
  let present = new Date().getFullYear();
  let t = new Date().getFullYear();
  while (i < t) {
    let from = i+1;
    from = from === 1960 ? from : from + 1;
    if (present != from || present <= from) {
      const to = i+6;
      y = [
        ...y,
        {
          label: `${from} - ${present > to ? to : 'present'}`,
          value: `${from},${to}`
        }
      ];
    }
    i = i+5;
  }

  return y;
}

const clickFilter = (d) => {
  d.setLoader(1);
  d.setEmpty(!1);

  let post = {
    surveyTypes: [],
    surveyLevels: [],
    phylum: [],
    class: [],
    ordo: [],
    family: [],
    genus: [],
    scientificNames: [],
    countries: [],
    siteTypes: [],
    startDate: d.year[0],
    endDate: d.year[1]
  }

  if (
    d.surveyType.length &&
    d.surveyType.length !== d.data.surveyTypes.length
  ) {
    d.surveyType.map(d => {
      return post.surveyTypes = [...post.surveyTypes,d.value];
    });
  }

  if (
    d.surveyLevel.length &&
    d.surveyLevel.length !== d.data.surveyLevels.length
  ) {
    d.surveyLevel.map(d => {
      return post.surveyLevels = [...post.surveyLevels,d.value];
    });
  }

  if (
    d.countries.length &&
    d.countries.length !== d.data.countries.length
  ) {
    d.countries.map(d => {
      return post.countries = [...post.countries,d.value];
    });
  }

  if (
    d.siteType.length &&
    d.siteType.length !== d.data.siteTypes.length
  ){
    d.siteType.map(d => {
      return post.siteTypes = [...post.siteTypes,d.value];
    });
  }

  if (
    d.species.phylum.length &&
    d.species.phylum.length !== d.data.phylum.length
  ) {
    d.species.phylum.map(d => {
      return post.phylum = [...post.phylum,d.value];
    });
  }

  if (
    d.species.class.length &&
    d.species.class.length !== d.data.class.length
  ) {
    d.species.class.map(d => {
      return post.class = [...post.class,d.value];
    });
  }

  if (
    d.species.ordo.length &&
    d.species.ordo.length !== d.data.ordo.length
  ) {
    d.species.ordo.map(d => {
      return post.ordo = [...post.ordo,d.value];
    });
  }

  if (
    d.species.family.length &&
    d.species.family.length !== d.data.family.length
  ) {
    d.species.family.map(d => {
      return post.family = [...post.family,d.value];
    });
  }
  
  if (
    d.species.genus.length &&
    d.species.genus.length !== d.data.genus.length
  ) {
    d.species.genus.map(d=>{
      return post.genus = [...post.genus,d.value];
    });
  }

  if (
    d.species.sn.length &&
    d.species.sn.length !== d.data.scientificNames.length
  ) {
    d.species.sn.map(d=>{
      return post.scientificNames = [...post.scientificNames,d.value];
    });
  }

  if (
    d.year[0] !== 1960 ||
    d.year[1] !== new Date().getFullYear()
  ) {
    post = {
      ...post,
      startDate: d.year[0],
      endDate: d.year[1]
    };
  }

  if (
    post.surveyTypes.length ||
    post.surveyLevels.length ||
    post.phylum.length ||
    post.class.length ||
    post.ordo.length ||
    post.family.length ||
    post.genus.length ||
    post.scientificNames.length ||
    post.countries.length ||
    post.siteTypes.length ||
    post.startDate !== 0 ||
    post.endDate !== 0
  ) {
    axios.post(`/gosearch`,post).then((r) => {
      if (r.data) {
        if (r.data.studyId) {
          d.setApp(filterAction({
            allMarkers: d.allMarkers,
            sid: r.data.studyId,
            label: `<b>Search result</b>`
          }));
        }else{
          d.setEmpty(1);
        }
      }
      d.setLoader(!1);
    });
  } else {
    d.setLoader(!1);
  }
}

const SallSpecies = () => {
  const thisYear = new Date().getFullYear();
  const location = useLocation();
  const setApp = useDispatch();
  const { map } = useSelector(s => s.map);
  const { sbBlock } = useSelector(s => s.sb);
  const { allMarkers } = useSelector(s => s.markers);

  const [empty, setEmpty] = useImmer(!1);
  const [data, setData] = useImmer(!1);
  const [loader, setLoader] = useState(!1);

  const [surveyTypeList, setSurveyTypeList] = useState([]);
  const [surveyType, setSurveyType] = useState([]);

  const [surveyLevelList, setSurveyLevelList] = useState([]);
  const [surveyLevel, setSurveyLevel] = useState([]);

  const [allSpecies, setAllSpecies] = useImmer([]);
  const [species, setSpecies] = useImmer({
    snList: [],
    sn: [],
    genusList: [],
    genus: [],
    familyList: [],
    family: [],
    ordoList: [],
    ordo: [],
    classList: [],
    class: [],
    phylumList: [],
    phylum: []
  });

  const [classList, setClassList] = useState([]);
  const [ordoList, setOrdoList] = useState([]);
  const [familyList, setFamilyList] = useState([]);
  const [genusList, setGenusList] = useState([]);
  const [snList, setSnList] = useState([]);

  const [countriesList, setcountriesList] = useState([]);
  const [countries, setcountries] = useState([]);

  const [siteTypeList, setSiteTypeList] = useState([]);
  const [siteType, setSiteType] = useState([]);

  const [year, setYear] = useState([1960, thisYear]);
  const [
    yearText,
    setYearText
  ] = useState(
    [
      '<span style="color:#206052">1960</span> ',
      '<i class="fa fa-long-arrow-right" style="color:#b3b3b3"></i> ',
      `<span style="color:#836f35">${thisYear}</span>`
    ].join('')
  );

  const { pathname } = location;

  useEffect(() => {
    if (pathname === '/search' && sbBlock !== 'Search') {
      batch(() => {
        setApp({ type: '_SIDEBAR', payload: ['sbBlock', 'Search'] });
        setApp({ type: '_FILTERED', payload: ['label', null] });
        setApp({ type: '_STUDY_DETAIL', payload: ['studyTitle', null] });
        setApp({ type: '_STUDY_DETAIL', payload: ['studyID', []] });
        setApp({ type: '_MARKERS_INIT' });
      });
    }
  }, [pathname, allMarkers]);

  useEffect(() => {
    if (sbBlock === 'Search' && !allSpecies.length) {
      axios.get('/tabs?data=Search&t='+new Date().getTime()).then(r => {
        const y = yearIntervals();
        setSurveyTypeList(r.data.surveyTypes);
        setSurveyLevelList(r.data.surveyLevels);
        setAllSpecies(r.data.species);
        setSpecies(d => {
          d.phylumList = r.data.phylum
          d.classList = r.data.class
          d.ordoList = r.data.ordo
          d.genusList = r.data.genus
          d.familyList = r.data.family
          d.snList = r.data.scientificNames
        });
        setClassList(r.data.class);
        setOrdoList(r.data.ordo);
        setFamilyList(r.data.family);
        setGenusList(r.data.genus);
        setSnList(r.data.scientificNames);

        setcountriesList(r.data.countries);
        setSiteTypeList(r.data.siteTypes);

        setData({ ...r.data, year: y });
      });
    }
  }, [sbBlock]);

  if (sbBlock !== 'Search') {
    return null;
  }

  return (
    <div className="sb-body-inner">
      <h6 className="sb-filter-text">
        <i className="fa fa-search" /> SEARCH OPTIONS
      </h6>

      <form>
        {
          !data && (
            <div className="lds-dual-ring2"></div>
          )
        }
        {
          data && (
            <>
              <div className="form-group">
                <p><b>Survey type</b></p>
                <MultiSelect hasSelectAll={false}
                  options={surveyTypeList}
                  value={surveyType}
                  onChange={setSurveyType}
                  labelledBy="All survey types"
                />
              </div>

              <div className="form-group">
                <p><b>Survey level</b></p>
                <MultiSelect hasSelectAll={false}
                  options={surveyLevelList}
                  value={surveyLevel}
                  onChange={setSurveyLevel}
                  labelledBy="All survey level"
                />
              </div>

              <div className="form-group">
                <p><b>Species</b></p>
                <div className="inner-form-group">
                  <div className="form-group">
                    <b>Phylum</b>
                    <MultiSelect hasSelectAll={false}
                      options={species.phylumList}
                      value={species.phylum}
                      onChange={(d)=>{
                        setSpecies(d2=>{
                          d2.phylum = d
                          d2.class = []
                          d2.ordo = []
                          d2.family = []
                          d2.genus = []
                          d2.sn = []
                        })
                        setClassList(setRelation({arr:allSpecies,val:d,col:['phylum','class']}) || species.classList)
                        setOrdoList(setRelation({arr:allSpecies,val:d,col:['phylum','ordo']}) || species.ordoList)
                        setFamilyList(setRelation({arr:allSpecies,val:d,col:['phylum','family']}) || species.familyList)
                        setGenusList(setRelation({arr:allSpecies,val:d,col:['phylum','genus']}) || species.genusList)
                        setSnList(setRelation({arr:allSpecies,val:d,col:['phylum','scientificNames']}) || species.snList)

                      }}
                      labelledBy="All Phylum"
                    />
                  </div>
                  <div className="row">

                    <div className="col-xs-12 col-sm-6">
                      <div className="form-group">
                          <b>Class</b>
                          <MultiSelect hasSelectAll={false}
                            options={classList}
                            value={species.class}
                            onChange={(d)=>{
                              setSpecies(d2=>{
                                d2.class = d
                                d2.ordo = []
                                d2.family = []
                                d2.genus = []
                                d2.sn = []
                              })
                              setOrdoList(setRelation({arr:allSpecies,val:d,col:['class','ordo']}) || species.ordoList)
                              setFamilyList(setRelation({arr:allSpecies,val:d,col:['class','family']}) || species.familyList)
                              setGenusList(setRelation({arr:allSpecies,val:d,col:['class','genus']}) || species.genusList)
                              setSnList(setRelation({arr:allSpecies,val:d,col:['class','scientificNames']}) || species.snList)

                            }}
                            labelledBy="All Class"
                          />
                        </div>
                      </div>
                    <div className="col-xs-12 col-sm-6">
                      <div className="form-group">
                        <b>Order</b>
                        <MultiSelect hasSelectAll={false}
                          options={ordoList}
                          value={species.ordo}
                          onChange={(d)=>{
                            setSpecies(d2=>{
                              d2.ordo = d
                              d2.family = []
                              d2.genus = []
                              d2.sn = []
                            })
                            setFamilyList(setRelation({arr:allSpecies,val:d,col:['ordo','family']}) || species.familyList)
                            setGenusList(setRelation({arr:allSpecies,val:d,col:['ordo','genus']}) || species.genusList)
                            setSnList(setRelation({arr:allSpecies,val:d,col:['ordo','scientificNames']}) || species.snList)
                          }}
                          labelledBy="All Orders"
                        />
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                    <div className="form-group">
                        <b>Family</b>
                        <MultiSelect hasSelectAll={false}
                          options={familyList}
                          value={species.family}
                          onChange={(d)=>{
                            setSpecies(d2=>{
                              d2.family = d
                              d2.genus = []
                              d2.sn = []
                            })
                            setGenusList(setRelation({arr:allSpecies,val:d,col:['family','genus']}) || species.genusList)
                            setSnList(setRelation({arr:allSpecies,val:d,col:['family','scientificNames']}) || species.snList)
                          }}
                          labelledBy="All Families"
                        />
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                      <div className="form-group">
                        <b>Genus</b>
                        <MultiSelect hasSelectAll={false}
                          options={genusList}
                          value={species.genus}
                          onChange={(d)=>{
                            setSpecies(d2=>{
                              d2.genus = d
                              d2.sn = []
                            })
                            setSnList(setRelation({arr:allSpecies,val:d,col:['genus','scientificNames']}) || species.snList)
                          }}
                          labelledBy="All Genus"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <b>Scientific name</b>
                    <MultiSelect hasSelectAll={false}
                      options={snList}
                      value={species.sn}
                      onChange={(d)=>{
                        setSpecies(d2=>{
                          d2.sn = d
                        })
                      }}
                      labelledBy="Scientific name"
                    />
                  </div>

                </div>
              </div>

              <div className="form-group">
                <p><b>countries</b></p>
                <MultiSelect hasSelectAll={false}
                  options={countriesList}
                  value={countries}
                  onChange={setcountries}
                  labelledBy="All countries"
                />
              </div>

              <div className="form-group">
                <p><b>Site type</b></p>
                <MultiSelect hasSelectAll={false}
                  options={siteTypeList}
                  value={siteType}
                  onChange={setSiteType}
                  labelledBy="All site types"
                />
              </div>

              <div className="form-group">
                <p><b>Years: <span dangerouslySetInnerHTML={{__html:yearText}}/></b></p>
                <div style={{
                  padding: "15px 25px 30px",
                  border: "1px solid #ccc",
                  background: "linear-gradient(45deg, #ebebeb, transparent)",
                  borderRadius: 4
                }}>
                  <Range
                    min={1960}
                    max={thisYear}
                    defaultValue={[1960, thisYear]}
                    value={year}
                    dots={false}
                    step={1}
                    marks={{
                      1960: 1960,
                      [thisYear]: thisYear,
                    }}
                    onChange={(v)=>{
                      setYear(v)
                      setYearText(`<span style="color:#206052">${v[0]}</span> <i class="fa fa-long-arrow-right" style="color:#b3b3b3"></i> <span style="color:#836f35">${v[1]}</span>`)
                    }}
                  />
                </div>
              </div>

              {
                empty ? (<div className="alert alert-danger"><b>No result!</b></div>) : null
              }

              <br/>

              {
                loader ? (
                  <div className="lds-dual-ring2"></div>
                ) : (
                  <button type="submit" onClick={(e)=>{
                    e.preventDefault()
                    clickFilter({
                      setLoader,
                      map,setApp,setEmpty,
                      data,
                      surveyType,
                      surveyLevel,
                      species,
                      countries,
                      siteType,
                      year,
                      allMarkers
                    })
                  }} className="btn btn-primary">Go Search</button>
                )
              }
              <br/><br/>

            </>
          )
        }

      </form>

    </div>
  );
};

export default SallSpecies;
